module.exports = __webpack_public_path__ + "img/profile-icon-empty.fad7b6d.svg";